// A place's point and profile as the CMS fills them (docs/cms-hub.md).

// As Google Maps copies a point with a right click: "-22.9090, -43.1765".
export const COORDINATES = /^(-?\d{1,2}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)$/

const inRange = (lat: number, lng: number) => Math.abs(lat) <= 90 && Math.abs(lng) <= 180

// The point in what was pasted: the numbers Google Maps copies, or a Google
// Maps link (".../@-22.9,-43.1,17z", "...!3d-22.9!4d-43.1", "?q=-22.9,-43.1").
// Null when it holds no point.
export function pointFromText(value: string): string | null {
  const text = value.trim()
  const plain = text.match(COORDINATES)
  if (plain) return inRange(Number(plain[1]), Number(plain[2])) ? `${plain[1]}, ${plain[2]}` : null
  if (!/^https?:\/\//i.test(text)) return null
  const decoded = decodeURIComponent(text)
  const patterns = [
    /!3d(-?\d{1,2}\.\d+)!4d(-?\d{1,3}\.\d+)/,
    /@(-?\d{1,2}\.\d+),(-?\d{1,3}\.\d+)/,
    /[?&](?:q|query|ll|center|destination)=(-?\d{1,2}\.\d+),\s*(-?\d{1,3}\.\d+)/,
  ]
  for (const pattern of patterns) {
    const match = decoded.match(pattern)
    if (match && inRange(Number(match[1]), Number(match[2]))) return `${match[1]}, ${match[2]}`
  }
  return null
}

// A profile's @ from a name: "Teatro Riachuelo" reads "teatroriachuelo".
export function suggestHandle(name: string) {
  const handle = name.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 30)
  return /[a-z]/.test(handle) && handle.length >= 3 ? handle : ''
}

export const STATES: [string, string][] = [
  ['AC', 'Acre'], ['AL', 'Alagoas'], ['AP', 'Amapá'], ['AM', 'Amazonas'], ['BA', 'Bahia'], ['CE', 'Ceará'],
  ['DF', 'Distrito Federal'], ['ES', 'Espírito Santo'], ['GO', 'Goiás'], ['MA', 'Maranhão'], ['MT', 'Mato Grosso'],
  ['MS', 'Mato Grosso do Sul'], ['MG', 'Minas Gerais'], ['PA', 'Pará'], ['PB', 'Paraíba'], ['PR', 'Paraná'],
  ['PE', 'Pernambuco'], ['PI', 'Piauí'], ['RJ', 'Rio de Janeiro'], ['RN', 'Rio Grande do Norte'],
  ['RS', 'Rio Grande do Sul'], ['RO', 'Rondônia'], ['RR', 'Roraima'], ['SC', 'Santa Catarina'], ['SP', 'São Paulo'],
  ['SE', 'Sergipe'], ['TO', 'Tocantins'],
]
